export const FORMATS_PROFIL = ['petit', 'moyen', 'grand', 'monumental'];
/** Bornes supérieures exclues du plus grand côté, en cm. */
export const SEUILS_FORMAT_CM = { petit: 40, moyen: 100, grand: 200 };
export function categorieFormat(dimensions, seuils) {
    if (!dimensions)
        return null;
    const cotes = [
        dimensions.hauteur,
        dimensions.largeur,
        dimensions.profondeur,
        dimensions.diametre,
    ].filter((cote) => cote !== undefined);
    if (cotes.length === 0)
        return null;
    // Le stockage est en cm ; uniteOrigine sert seulement à réafficher la saisie.
    const cote = Math.max(...cotes);
    if (cote < seuils.petit)
        return 'petit';
    if (cote < seuils.moyen)
        return 'moyen';
    if (cote < seuils.grand)
        return 'grand';
    return 'monumental';
}
//# sourceMappingURL=format.js.map